import classes from "./Advantage.module.scss";
import Tooltip from '../../Tooltip/tooltip';

import icon1 from "../../Assets/Img/Src/Svg/Icon/icon1.svg"
import icon2 from "../../Assets/Img/Src/Svg/Icon/icon2.svg"
import icon3 from "../../Assets/Img/Src/Svg/Icon/icon3.svg"
import icon4 from "../../Assets/Img/Src/Svg/Icon/icon4.svg"


const Advantage = () => {
  return (

    <div className={classes.Advantage}>
        <div className={classes.Item}>
        <div className={classes.Icon}><img src={icon1} alt="" /></div>
          <h5 className={classes.Title}>
          Крупнейший производитель в России
        </h5>
          <p className={classes.Description}>
          Компания «ТОПОЛ-ЭКО» первый и крупнейший в России производитель автономных канализаций, работающих по аэрационному принципу.
          </p>
        </div>
        <div className={classes.Item}>
          <div className={classes.Icon}><img src={icon2} alt="" /></div>
          <h5 className={classes.Title}>4000 дилеров по всей стране
        </h5>
          <p className={classes.Description}>Дилеры компании находятся более чем в 4000 городах и населенных пунктах России.
        </p>
        </div>
        <div className={classes.Item}>
          <div className={classes.Icon}><img src={icon3} alt="" /></div>
          <h5 className={classes.Title}>На момент знакомства ТОПОЛ-ЭКО было уже более 16 лет
        </h5>
          <p className={classes.Description}>
          Компания успела поработать с различными подрядчиками, как по технической части, так и по направлению SEO.
        </p>
        </div>
        <div className={classes.Item}>
        <div className={classes.Icon}><img src={icon4} alt="" /></div>
        <h5 className={classes.Title}>
          ТОПОЛ-ЭКО
          <br/>
          +
          <br/>  
          Semprogroup
      </h5>
        <p className={classes.Description}> 
        В середине 2016 года компания ТОПОЛ-ЭКО привлекла нас в качестве подрядчика по технической поддержке и SEO.
      </p>
      </div>
    </div>
    
  )
}

export default Advantage;